export default {
  de: {
    organisation: 'Organisation',
    cities: 'Gemeinden',
    printers: 'Druckanbieter',
    users: 'Benutzer',
    variables: 'Variablen',
  },
};
